import React from 'react';
import Image from 'src/components/Image';

import { DemoTemplate } from 'src/templates';
import ContentCards from 'src/components/content-cards';

import {
  metaData,
  cardSectionData,
  pageHeaderPIData,
} from 'src/store/accounts';

const Payment = () => {
  return (
    <DemoTemplate {...metaData}>
      <div className='page-header page-header-web3-theme background background--color-black100'>
        <div className='grid-container'>
          <div className='grid-x align-center grid-margin-x'>
            <div className='cell small-12 medium-4'>
              <div className='grid-x'>
                <div className='cell small-12 page-header-breakpoint-12'>
                  <h1 className='page-header-header'>
                    {pageHeaderPIData.status}
                  </h1>
                  <h4 className='regular page-header-subheader'>
                    {pageHeaderPIData.subtext}
                  </h4>
                </div>
              </div>
            </div>
            <div className='cell small-12 medium-8 page-header-bg-wrapper'>
              <div>
                <div className='demo-accent'>
                  <Image
                    src='https://images.ctfassets.net/ss5kfr270og3/3rdsesKs5mC5bNKBlUWfAk/cd07dad6bcee7d1f4e13ecebda0e4816/homepage-howitworks-brushstroke-left.png?fm=webp&q=70'
                    alt=''
                  />
                </div>
                <div className='code-container code-container--tall code-container--z-index code-container--no-margin'>
                  <header className='code-container-header'>
                    <p className='code-container-header-title'>
                      GET /payment/get
                    </p>
                  </header>
                  <div className='code-container-body code-product-example'>
                    <div className='code-example is-active'>
                      <pre>
                        {' '}
                        <code
                          id='payment-get-response'
                          className='language-json'
                        >{`
                  `}</code>
                      </pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ContentCards {...cardSectionData} />
    </DemoTemplate>
  );
};

export default Payment;
